import { type Plugin } from "@nuxt/types";

import { type AmplitudeExperiment } from "@/types";

declare module "vue/types/vue" {
  interface Vue {
    $experiments?: AmplitudeExperiment;
  }
}

declare module "@nuxt/types" {
  interface Context {
    $experiments?: AmplitudeExperiment;
  }
}

declare module "vuex/types/index" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Store<S> {
    $experiments?: AmplitudeExperiment;
  }
}

const plugin: Plugin = async ({ $experiments }, _inject) => {
  await $experiments?.identifyUser();
};

export default plugin;
